import Icon from "~/components/ui/Icon"
import { HTMLWidget } from "~/types/widgets"

/**
 * @titleBy label
 */
interface Item {
    label: string
    url: string
}

/**
 * @titleBy title
 */
export interface Props {
    /**
     * @title Título
     */
    title: string
    /**
     * @title Itens
     * @description Lista de itens que será renderizado com prioridade (caso queira que o conteúdo personalizado seja renderizado, remova os itens dessa opção).
     */
    items?: Item[]
    /**
     * @title Conteúdo
     * @description Conteúdo personalizado
     */
    content?: HTMLWidget
    /**
     * @title Aberto
     * @description Escolha se o componente deverá vir aberto por padrão
     */
    open?: boolean
    /**
     * @ignore
     */
    isMobile?: boolean
}

export default function Service({ title, items, content, open = false, isMobile }: Props) {
    if (isMobile) {
        return (
            <div className='w-full'>
                <div className='relative text-sm rounded-none collapse'>
                    <input
                        type='checkbox'
                        id={`input-${title}`}
                        className='fixed hidden peer'
                        checked={open}
                    />
                    <label
                        htmlFor={`input-${title}`}
                        className='flex items-center justify-between w-full h-12 min-h-0 p-0 text-base font-bold swap swap-rotate peer-checked:swap-active collapse-title text-salmon-light'
                    >
                        <span>{title}</span>
                        <Icon
                            id='ChevronRight'
                            size={24}
                            strokeWidth={2}
                            className='absolute -translate-y-1/2 swap-off right-3 top-1/2'
                        />
                        <Icon
                            id='ChevronDown'
                            size={20}
                            strokeWidth={2}
                            className='absolute -translate-y-1/2 swap-on right-3 top-1/2'
                        />
                    </label>
                    <div className='collapse-content !p-0'>
                        <div className='px-0 pt-2 pb-4'>
                            {items && items.length > 0
                                ? (
                                    <ul className='space-y-3'>
                                        {items.map(({ label, url }) => (
                                            <li>
                                                <a
                                                    className='flex items-center w-full font-bold'
                                                    href={url}
                                                >
                                                    <span>{label}</span>
                                                </a>
                                            </li>
                                        ))}
                                    </ul>
                                )
                                : content
                                ? <div dangerouslySetInnerHTML={{ __html: content }} />
                                : <></>}
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className='space-y-3'>
            <p className='font-bold text-salmon-light'>{title}</p>
            {
                <ul className='flex flex-col text-sm font-semibold text-white leading-6'>
                    {items && items.length
                        ? (
                            items.map(({ label, url }) => (
                                <li>
                                    <a href={url}>{label}</a>
                                </li>
                            ))
                        )
                        : content
                        ? (
                            <li>
                                <div dangerouslySetInnerHTML={{ __html: content }} />
                            </li>
                        )
                        : <></>}
                </ul>
            }
        </div>
    )
}
